import { memo, useCallback } from "react";
import { MessageCircle } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLocation } from "react-router-dom";
import { pushToDataLayer } from "@/utils/dataLayerUtils";
import { useAmplitudeEvents } from "@/utils/amplitudeEvents";

interface WhatsAppButtonProps {
  isVisible?: boolean;
}

const WhatsAppButton = memo(({ isVisible = true }: WhatsAppButtonProps) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const { trackWhatsAppClicked } = useAmplitudeEvents();

  const isPropertyDetailPage =
    location.pathname.startsWith("/propiedades/") ||
    location.pathname.startsWith("/property/");

  const shouldUseAboveBookingBar = isMobile && isPropertyDetailPage;

  const handleWhatsAppClick = useCallback(() => {
    trackWhatsAppClicked();

    pushToDataLayer({
      event: "whatsApp_clicked",
    });

    const whatsappUrl =
      "https://api.whatsapp.com/send?phone=+523335781778&text=Hola!+Me+gustar%C3%ADa+realizar+una+reservaci%C3%B3n.";
    window.open(whatsappUrl, "_blank");
  }, [trackWhatsAppClicked]);

  const buttonStyle = shouldUseAboveBookingBar
    ? ({
        bottom: "5.5rem",
        right: "1.5rem",
        position: "fixed",
        zIndex: 100,
        transition: "bottom 0.3s",
      } as React.CSSProperties)
    : ({
        bottom: "1.5rem",
        right: "1.5rem",
        position: "fixed",
        zIndex: 100,
      } as React.CSSProperties);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={handleWhatsAppClick}
      style={buttonStyle}
      className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center z-50"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={28} />
    </button>
  );
});

WhatsAppButton.displayName = "WhatsAppButton";

export default WhatsAppButton;
